// features/hives/ui/hivesNew/styles.ts
import {COLORS} from 'shared/consts';
import {toRem} from 'shared/helpers';
import styled from 'styled-components';

export const NewHiveWrapper = styled.form`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  @media (width < ${toRem(768)}) {
    width: 100vw;
  }
`;

type NewHiveHeadProps = {
  $isMobile?: boolean;
};
export const NewHiveHead = styled.div<NewHiveHeadProps>`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: ${(props) => (props.$isMobile ? 'row-reverse' : 'column')};
  gap: ${toRem(12)};
  justify-content: space-between;
  align-items: ${(props) => (props.$isMobile ? 'center' : 'initial')};
`;

export const NewHiveTitle = styled.h2`
  display: flex;
  gap: ${toRem(12)};
  justify-content: space-between;
  font-weight: 700;
  font-size: ${toRem(22)};
  line-height: ${24 / 22};
  color: ${COLORS.FG.DEFAULT};

  @media (width < ${toRem(768)}) {
    font-size: ${toRem(16)};
  }

  button {
    color: ${COLORS.ACCENT.DEFAULT};
  }
`;

export const NewHiveBody = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  @media (width >= ${toRem(540)}) {
    width: ${toRem(540)};
  }
  @media (width < ${toRem(540)}) {
    width: 100vw;
  }
`;

type NewHiveRowProps = {
  $alignItems?: React.CSSProperties['alignItems'];
};

export const NewHiveRow = styled.div<NewHiveRowProps>`
  display: flex;
  align-items: ${(props) => props.$alignItems || 'center'};
  gap: ${toRem(12)};
  flex-wrap: wrap;
  margin: ${toRem(6)} 0;
  position: relative;

  > .input {
    margin-top: 0;
    max-width: 220px;
  }

  > span {
    flex: 0 0 ${toRem(120)};
    font-weight: 500;
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
  }

  @media (width >= ${toRem(540)}) {
    .popover__root,
    .dropdown-menu-root {
      min-width: ${toRem(220)};
      max-width: ${toRem(220)};
    }
  }

  .tagitem__label {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};

    img {
      max-width: ${toRem(20)};
      aspect-ratio: 1;
    }
  }

  i {
    color: ${COLORS.FG.MUTED};
  }
`;

export const NewHiveBorder = styled.div`
  width: 100%;
  height: ${toRem(1)};
  margin: ${toRem(6)} 0;
  background-color: ${COLORS.BORDER.MUTED};
`;

export const NewHiveFooter = styled.div`
  padding: ${toRem(12)} ${toRem(16)};
  border-top: ${toRem(1)} solid ${COLORS.BORDER.SOFT};
  display: flex;
  gap: ${toRem(16)};

  @media (width < ${toRem(768)}) {
    display: flex;
    flex-direction: column-reverse;
    gap: ${toRem(12)};
  }
`;

export const ColorPickerWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

type ColorPickerItemProps = {
  $isActive?: boolean;
  $color: string;
};

export const ColorPickerItem = styled.div<ColorPickerItemProps>`
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
  transition: all 0.2s ease;

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(${(props) => props.$color}, rgba(255, 255, 255, 0));
    z-index: 2;
  }

  &:before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    transition: all 0.2s ease;
    z-index: 1;

    ${({$isActive}) =>
      $isActive
        ? `
            width: 24px;
            height: 24px;
            box-shadow:
                0 0 0 4px rgba(255, 79, 18, 0.15);
        `
        : `
            width: 22px;
            height: 22px;
            background: transparent;
            box-shadow: none;
        `}
  }

  ${({$isActive}) =>
    $isActive
      ? `
        border: 2px solid #ff6012;
    `
      : `
        border: 2px solid var(--radiobutton-primary-border-color-default);
    `}
`;

export const SuggestWrap = styled.div`
  position: relative;
  flex: 0 0 ${toRem(220)};
  max-width: ${toRem(220)};
`;

export const Suggest = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + ${toRem(6)});
  background: ${COLORS.BG.SURFACE1};
  border-radius: ${toRem(8)};
  padding: ${toRem(6)};
  max-height: ${toRem(300)};
  overflow-y: auto;
  z-index: 50;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
`;

export const SuggestItem = styled.div`
  padding: ${toRem(8)} ${toRem(10)};
  border-radius: ${toRem(6)};
  cursor: pointer;
  user-select: none;

  &:hover {
    background: var(--input-primary-bg-color-default, #f6f7f9);
  }
`;

type NewEntrieHeadProps = {
  $isMobile?: boolean;
};
export const NewEntrieHead = styled.div<NewEntrieHeadProps>`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: ${(props) => (props.$isMobile ? 'row-reverse' : 'column')};
  gap: ${toRem(12)};
  justify-content: space-between;
  align-items: ${(props) => (props.$isMobile ? 'center' : 'initial')};
`;

export const NewEntrieTitle = styled.h2`
  display: flex;
  gap: ${toRem(12)};
  justify-content: space-between;
  font-weight: 700;
  font-size: ${toRem(22)};
  line-height: ${24 / 22};
  color: ${COLORS.FG.DEFAULT};

  @media (width < ${toRem(768)}) {
    font-size: ${toRem(16)};
  }

  button {
    color: ${COLORS.ACCENT.DEFAULT};
    font-size: ${toRem(16)};
  }
`;
